import { Timestamp } from 'firebase/firestore';
import { AbstractDatabaseObject } from '../../tandem-core/models/abstract-database-object';

export type ReleaseStatus = 'draft' | 'published';

export interface ReleaseChange {
  text: string;
  category?: 'feature' | 'improvement' | 'fix' | 'other';
}

export interface ReleaseCommit {
  hash: string;
  message: string;
  author?: string;
  date?: string;
}

export interface Release extends AbstractDatabaseObject {
  version: string;
  status: ReleaseStatus;
  title?: string;
  changes: ReleaseChange[];
  rawCommits?: ReleaseCommit[];
  publishedAt?: Timestamp;
  createdBy: string;
  createdByName?: string;
}

export function compareVersions(v1: string, v2: string): number {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);
  
  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const p1 = parts1[i] || 0;
    const p2 = parts2[i] || 0;
    if (p1 > p2) return 1;
    if (p1 < p2) return -1;
  }
  return 0;
}

export function isNewerVersion(current: string, lastSeen: string | null | undefined): boolean {
  if (!lastSeen) return true;
  return compareVersions(current, lastSeen) > 0;
}
